// src/components/nav-bar.js

import React, { useState, useContext, useEffect } from 'react';
import AuthNav from './auth-nav';
import { GuestNav, AdminNav, TitleNav, NotaryNav } from '../components'
import { NavLink } from "react-router-dom";
import { UserContext } from "../app"
import mixpanel from 'mixpanel-browser';

const NavBar = (props) => {
  const { userProfile, setUser } = useContext(UserContext)
  const [isNotary, setIsNotary] = useState(false)
  const [isAdmin, setIsAdmin] = useState(false)
  const [isTitle, setIsTitle] = useState(false)
  const [isGuest, setIsGuest] = useState(true)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  function sendEvent(e) {
    mixpanel.identify(e.profileEmail)
    mixpanel.people.set({
      $role: e.profileRole,
      $email: e.profileEmail,
      $name: e.profileName,
      $organization: e.profileOrganization
    })
  }

  useEffect(() => {
    if (userProfile.profileRole === 'admin' || userProfile.profileRole === 'creator' || userProfile.profileRole === 'sub_admin' || userProfile.profileRole === 'notary') {
      sendEvent(userProfile)
    } else {
      sendEvent(userProfile)
    }
    if (userProfile.profileRole === 'creator') {
      setIsTitle(true)
      setIsGuest(false)
    }
    if (userProfile.profileRole === 'admin' || userProfile.profileRole === 'sub_admin') {
      setIsAdmin(true)
      setIsGuest(false)
    }
    if (userProfile.profileRole === 'notary') {
      setIsNotary(true)
      setIsGuest(false)
    }
  }, [userProfile, setUser]);

  return (
    <div className="mb-4">
      <nav className="bg-white border-b border-neutral-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <NavLink
              to="/"
              exact
              className="navbar-brand flex-shrink-0"
              activeClassName="router-link-exact"
            />

            {/* Desktop Navigation */}
            <div className="hidden lg:flex lg:items-center lg:gap-1 flex-1 justify-center">
              {isNotary && <NotaryNav />}
              {isGuest && <GuestNav />}
              {isAdmin && <AdminNav />}
              {isTitle && <TitleNav />}
              <AuthNav />
            </div>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden p-2 rounded-lg text-neutral-600 hover:bg-neutral-100 hover:text-neutral-900 transition-colors"
              aria-label="Toggle navigation menu"
            >
              {isMobileMenuOpen ? (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMobileMenuOpen && (
            <div className="lg:hidden py-4 border-t border-neutral-100">
              <div className="flex flex-col gap-2">
                {isNotary && <NotaryNav />}
                {isGuest && <GuestNav />}
                {isAdmin && <AdminNav />}
                {isTitle && <TitleNav />}
                <AuthNav />
              </div>
            </div>
          )}
        </div>
      </nav>
    </div>
  );
};

export default NavBar;
